import React, { useState } from 'react';
import { Button, Modal } from 'antd';
import SuccessModal from '../SuccessModal';
import FormInput from '../../FormInput';
import useForm from '../../../../hooks/useForm';
import { toast } from 'react-toastify';
import { approveBill, getMyRecord, rejectdPaymentBill } from '../../../../store/actions';
import { useDispatch } from 'react-redux';

const PreviewTransportOrderModal = ({billId, title, openModal, handleOk, handleCancel, d_location, a_location, imgUrl, a_time, d_time, amount, date, ticket, f_name,l_name, email, phone }) => {
  const [secondModalOpen, setSecondModalOpen] = useState(false);
  const [openFailed, setOpenedFailed] = useState(false);
  const dispatch = useDispatch()
  const initialState = {
    desc: '',
  };

  const { values, handleChange, resetForm, errors } = useForm(initialState);

  const handleProceed = () => {
    setSecondModalOpen(true);
  };

  const handleReturn = () => {
    setOpenedFailed(true);
  };

  const handleSubmit = async(e) => {
    e.preventDefault();

    try {
      const res = await dispatch(approveBill(billId));
       
      if (res.payload.statusCode){
        dispatch(getMyRecord('today'))
        handleProceed();
      }
    } catch (error) {
      
    }
    resetForm();
  };

  const handleReject = async(e) => {
    e.preventDefault();
    const params = {
      billId,
      paylaod:{
        rejectionReason:values.desc
      }
      
    }

    try {
      const res = await dispatch(rejectdPaymentBill(params));
 
      if (res.payload.statusCode){
        toast.success('Bill Rejected Successfully')
        dispatch(getMyRecord('today'))
        handleReturn();
      }else{
        toast.error('Bill Rejected Unsuccessfully')
        handleCancel()
      }
    } catch (error) {
      toast.error('Something went wrong')
      handleCancel()
    }

     
    // setOpenedFailed(false);
    handleCancel?.(); 
    resetForm();
  };
  return (
    <>
      <SuccessModal
        title={`Transport Transaction performed successfully`}
        openModal={secondModalOpen}
        handleContinue={() => {setSecondModalOpen(false); handleOk?.();}}
        handleCancel={() => {setSecondModalOpen(false); handleOk?.();}}
        handleOk={() => {setSecondModalOpen(false); handleOk?.();}}
      />

      <Modal
        className="basic-modal"
        title="Transport Order Failed"
        open={openFailed}
        onOk={() => setOpenedFailed(false)}
        onCancel={() => setOpenedFailed(false)}
      >
        <div className="flex items-center justify-center gap-6 md:px-[2rem] flex-col w-full">
          {imgUrl && <img src={imgUrl} alt="Failure reason" />}

          <FormInput
            label="Reason"
            type="textarea"
            name="desc"
            value={values.desc}
            onChange={handleChange}
            placeholder="Describe why the transaction failed"
            error={errors?.desc}
          />

          <div className="flex items-center justify-center w-full">
            <button
              onClick={handleReject}
              className="bg-[#219653] rounded-[8px] text-white py-[10px] px-11 text-[14px] md:text-[16px] font-[500] leading-[24px]"
            >
              Submit
            </button>
          </div>
        </div>
      </Modal>

      <Modal className='basic-modal' title={'Transport Order'} open={openModal} onOk={handleOk} onCancel={handleCancel}>
        <div  className='flex items-center justify-center gap-6 md:px-[2rem] flex-col w-full pt-6'>
          {imgUrl && <img src="" alt="" />}
          
          <div className='w-full grid grid-cols-2 gap-3'>
            <span className='text-[14px]'>Departure Location:</span>
            <span className='font-bold text-[16px]'>{d_location}</span>
            <span className='text-[14px]'>Arrival Location:</span>
            <span className='font-bold text-[16px]'>{a_location}</span>
            <span className='text-[14px]'>Date:</span>
            <span className='font-bold text-[16px]'>{date}</span>
            <span className='text-[14px]'>Time:</span>
            <span className='font-bold text-[16px]'>{d_time} - {a_time}</span>
            <span className='text-[14px]'>No of Ticket:</span>
            <span className='font-bold text-[16px]'>{ticket}</span>
            <span className='text-[14px]'>Amount:</span>
            <span className='font-bold text-[16px]'>{amount}</span>
          </div>
          <span className='py-1 w-full bg-slate-400 mt-4 rounded-md px-2'>Customer Details</span>
          <div className='w-full grid grid-cols-2 gap-3'>
            <span className='text-[14px]'>First Name:</span>
            <span className='font-bold text-[16px]'>{f_name}</span>
            <span className='text-[14px]'>Last Name:</span>
            <span className='font-bold text-[16px]'>{l_name}</span>
            <span className='text-[14px]'>Email:</span>
            <span className='font-bold text-[16px]'>{email}</span>
            <span className='text-[14px]'>Phone Number:</span>
            <span className='font-bold text-[16px]'>{phone}</span>
          </div>



          <div className='flex items-center justify-between w-full'>
            <button onClick={handleSubmit} className='bg-[#219653] rounded-[8px] text-white py-[10px] px-11 text-[14px] md:text-[16px] font-[500] leading-[24px]'>Completed</button>
            <button onClick={handleReturn} className='bg-[red] rounded-[8px] text-white py-[10px] px-11 text-[14px] md:text-[16px] font-[500] leading-[24px]'>Failed</button>
          </div>                
        </div>

      </Modal>
    </>
  );
};
export default PreviewTransportOrderModal;